import axiosPost from "../axiosPost";

export const hotelGet = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFHotelGet",
        params: {
            SFHotelNombre: params?.SFHotelNombre,
            SFHotelStatus: params?.SFHotelStatus,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
